import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import {UndoTwoTone, PageviewTwoTone } from '@material-ui/icons';


export default class ViewAssessment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            pending_assessments_array: [],
            create_assessment: false,
            assessment: {},
            show_assessment: false,
            data_points: [],
            fetching_preview: false,
            file_url: null,
            overriding: false,
            override_value: '',
            override_comment: '',
            writing: false,
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
            competency_header: ''
        }
    }

    componentDidMount = () => {
        // console.log('this.props.assessment :>> ', this.props.assessment);
        this.setState({
            querying:true,
            override_value:this.props.assessment.key_datapoint_score_override? this.props.assessment.key_datapoint_score_override : '',
            override_comment:this.props.assessment.override_comment? this.props.assessment.override_comment : '',
            show_assessment:true
        });
        Gserv.sendCommand('query_assessment_datapoints',this.props.gwt,{
            assessment_key: this.props.assessment.id
        })
        .then(reply => {
            // console.log('query datapoints reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_assessment_datapoints) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (query_assessment_datapoints) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({querying:false, data_points:reply.Records?reply.Records : [], fetching_preview: this.props.assessment.file_attachment_required!==0? true : false, competency_header: reply.Records? (reply.Records[0].narration? reply.Records[0].narration.split('|')[0] : ''): ''});


                if (this.props.assessment.file_attachment_required!==0){
                    //Fetch .pdf preview...
                    // console.log('this.props :>> ', this.props);
                    Gserv.sendCommand('fetch_assessment_file_url',this.props.gwt,{
                        attachment_name: this.props.assessment.attachment_name,
                        assessment_template_id: this.props.assessment.assessment_template_id
                    })
                    .then(reply => {
                        // console.log('fetch assessment file reply :>> ', reply);
                        if (reply.error){
                            console.log('error on return from Gserv (fetch_assessment_file_url) :>> ', reply);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else if (reply.Result!=="Success"){
                            console.log('error on return from Gserv (fetch_assessment_file_url) :>> ', reply);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else {
                            // console.log('fetch_assessment_file ok')
                            this.setState({file_url:reply.Url, fetching_preview:false});
                        }
                    });
            
                }

            }
        });
    };

    backToParent = () => {
        this.props.closeChild();
    }
   
    openFile = () => {
        const newWindow = window.open(this.state.file_url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null
    }
  
    render() {
        const assessment = this.props.assessment;
        const key_code = assessment.key_datapoint_code;
        return(
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
 
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1075,
                    paddingBottom:'15px'
                }}
            >

                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1075,
                        // padding:15,
                    }}
                >
                    <Tooltip title="Back"><IconButton aria-label='Back' onClick={this.backToParent}><UndoTwoTone /></IconButton></Tooltip>
                </Paper>

                <Typography
                    style={{borderWidth:'1px',borderStyle:'solid',padding:'10px'}}
                >
                    <strong>{assessment.assessment_template.toUpperCase()}</strong>
                    {this.state.competency_header&&<span> ({this.state.competency_header})</span>}
                    <br/>
                    <b>{assessment.assessment_type}</b> assessment for <b>{assessment.assessee}</b> ({assessment.job_title}) for cycle <b>{assessment.cycle_code}</b>
                </Typography>

                <Grid container direction='row' justifyContent='center' alignItems='center'>  
                    
                    <Grid item xs={8}>
                        <Grid 
                            container
                            direction='column' justifyContent='flex-start' alignItems='flex-start'
                            style={{paddingTop:'15px',paddingBottom:'15px',paddingLeft:'75px'}}
                        >
                            <Typography><u>Assessment Data Points</u></Typography>
                            {this.state.data_points.map(function(item, i){
                                if (item.comment) {
                                    return (<Typography key={item.datapoint_id}>{item.datapoint_code.replace(/_/g,' ')} : <b>{item.comment}</b></Typography>)
                                } else {
                                    // console.log('key_code :>> ', key_code);
                                    if (item.datapoint_code===key_code){
                                        return (<Typography color='primary' style={{backgroundColor:'#e6e7e8'}} key={item.datapoint_id}>{item.datapoint_code.replace(/_/g,' ')} : <b>{item.score}</b> out of {item.score_out_of}</Typography>)
                                    } else {
                                        return (<Typography key={item.datapoint_id} style={{textAlign:'left'}}>
                                            {/* More detail provided where item is a competency */}
                                            {item.narration&&
                                            <span><b>{item.narration.split('|')[1]}</b> : {item.narration.split('|')[2]}<br/></span>}

                                            {item.datapoint_code.replace(/_/g,' ')} : <b>{item.score}</b> out of {item.score_out_of}

                                             {/* More detail provided where item is a competency */}
                                             {item.narration&&
                                            <span><b>{item.score==='0.000'? " [ NOT YET COMPETENT ]" : (item.score==='1.000'? " [ COMPETENT ]" : " [ EXPERT ]") }</b></span>}

                                        </Typography>)
                                    }
                                }
                            })}
                        </Grid>
                    </Grid>

                    {assessment.key_datapoint_score_override&&!this.state.overriding&&        
                    <Grid item xs={6}>
                        <Grid 
                            container
                            direction='column' justifyContent='center' alignItems='center'
                            style={{paddingTop:'15px',paddingBottom:'15px',paddingLeft:'75px', paddingRight:'75px'}}
                        >
                            <div style={{borderWidth:'1px',borderStyle:'dashed', padding:'15px'}}>
                                <Typography>Admin Override Applied: </Typography>
                                <hr style={{width:'100%'}}/>

                                <Typography color='primary' style={{backgroundColor:'#e6e7e8'}}>{assessment.key_datapoint_code.replace(/_/g,' ')} : <b>{assessment.key_datapoint_score_override}</b> out of {assessment.key_datapoint_out_of}</Typography>

                                <Typography><b>Comment:</b> {assessment.override_comment}</Typography>
                            </div>
                           
                        </Grid>
                    </Grid>}

                </Grid>

                <hr/>

                {(assessment.file_attachment_required!==0)&&!this.state.fetching_preview&&                
                <span><Tooltip title="Open File Attachment">    
                <IconButton 
                    onClick={()=>this.openFile()} 
                >
                    <PageviewTwoTone color='primary' fontSize="large"/>
                </IconButton>
                </Tooltip> &nbsp;&nbsp;&nbsp;</span>}
                
            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1310,maxWidth:1310, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.backToParent}>Back</Button>}
            </Grid>

        </Grid>
    )}
    
}